import { render, staticRenderFns } from "./Line-Item-Detail-New.vue?vue&type=template&id=c5f0c3d8"
import script from "./Line-Item-Detail-New.vue?vue&type=script&lang=js"
export * from "./Line-Item-Detail-New.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports